import React from 'react';
import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';

import TagLink from './components/TagLink';

function Header() {
  const page = useTypedSelector(selectSinglePost);
  const parentRoute = useRouter().asPath.split('/')[1];
  const splitDate = page?.datePublished?.split('-');
  const formatDate = `${
    splitDate && splitDate[2] + '.' + splitDate[1] + '.' + splitDate[0]
  }`;

  if (!page) {
    return null;
  }

  return (
    <Component>
      <Date id="post-date">
        {parentRoute === 'offers' ? page.deadlineText : formatDate}
      </Date>
      <Title id="post-title">{page.title}</Title>
      <TagsList>
        {page.tags.map(({ tag, urlAlias }, index) => (
          <TagLink key={index} tag={tag} urlAlias={urlAlias} />
        ))}
      </TagsList>
    </Component>
  );
}

export default Header;

const Component = styled.div`
  display: flex;
  flex-direction: column;
`;

const Date = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.gray500};
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  margin: 10px 0 0;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 28px;
    line-height: 36px;
  `)}

  ${media.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)}
`;

const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
`;
